import React from 'react';
import { CheckCircle2 } from 'lucide-react';
export function WhyUs() {
  const benefits = ['Consistent, perfect water chemistry', 'Catch equipment problems early before they cost thousands', 'Zero maintenance hassle for you', 'Predictable flat-rate monthly billing', 'More time to actually enjoy your pool'];
  const steps = [{
    num: '01',
    title: 'Request a Quote',
    desc: 'Fill out our quick form or call us.'
  }, {
    num: '02',
    title: 'Free Assessment',
    desc: "We evaluate your pool's needs."
  }, {
    num: '03',
    title: 'Get on the Route',
    desc: 'We schedule your weekly service day.'
  }, {
    num: '04',
    title: 'Relax & Swim',
    desc: 'Enjoy a pristine pool year-round.'
  }];
  return <section id="why-us" className="py-24 bg-white overflow-hidden" data-id="element-234">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-235">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-236">
          {/* Left: Benefits */}
          <div data-id="element-237">
            <h2 className="text-3xl md:text-4xl font-extrabold text-slate-900 mb-6" data-id="element-238">
              Why get on a weekly route?
            </h2>
            <p className="text-lg text-slate-600 mb-8 leading-relaxed" data-id="element-239">
              Owning a pool in California should be a luxury, not a part-time
              job. Our weekly route customers enjoy peace of mind knowing their
              investment is protected and always ready for a swim.
            </p>

            <div className="space-y-4 mb-10" data-id="element-240">
              {benefits.map((benefit, idx) => <div key={idx} className="flex items-start gap-3" data-id="element-241">
                  <CheckCircle2 className="w-6 h-6 text-blue-500 shrink-0 mt-0.5" data-id="element-242" />
                  <span className="text-slate-700 font-medium text-lg" data-id="element-243">
                    {benefit}
                  </span>
                </div>)}
            </div>

            <button onClick={() => document.getElementById('contact')?.scrollIntoView({
            behavior: 'smooth'
          })} className="bg-slate-900 hover:bg-slate-800 text-white px-8 py-4 rounded-full font-bold transition-all" data-id="element-244">
              Secure Your Spot on the Route
            </button>
          </div>

          {/* Right: How it works */}
          <div className="bg-slate-50 rounded-3xl p-8 md:p-12 border border-slate-100" data-id="element-245">
            <h3 className="text-2xl font-bold text-slate-900 mb-8" data-id="element-246">
              How it works
            </h3>
            <div className="space-y-8 relative before:absolute before:inset-0 before:ml-6 before:-translate-x-px md:before:mx-auto md:before:translate-x-0 before:h-full before:w-0.5 before:bg-gradient-to-b before:from-transparent before:via-slate-200 before:to-transparent hidden md:block" data-id="element-247"></div>

            <div className="space-y-8" data-id="element-248">
              {steps.map((step, idx) => <div key={idx} className="relative flex items-start gap-6" data-id="element-249">
                  <div className="w-12 h-12 rounded-full bg-white border-2 border-blue-100 flex items-center justify-center text-blue-600 font-bold text-lg shrink-0 shadow-sm z-10" data-id="element-250">
                    {step.num}
                  </div>
                  <div className="pt-2" data-id="element-251">
                    <h4 className="text-xl font-bold text-slate-900 mb-2" data-id="element-252">
                      {step.title}
                    </h4>
                    <p className="text-slate-600" data-id="element-253">{step.desc}</p>
                  </div>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}